import {
  Action,
  ActionType,
  DeleteBusinessUserResponse,
} from "models/userListBusiness/deleteBusinessUser";

import createReducer from "../../createReducer";

export interface DeleteBusinessUserReducerType {
  loading: boolean;
  error?: string;
  deleteBusinessUserResponse?: DeleteBusinessUserResponse;
}

const defaultState: DeleteBusinessUserReducerType = {
  loading: false,
  error: undefined,
  deleteBusinessUserResponse: undefined,
};

export const deleteBusinessUserReducer =
  createReducer<DeleteBusinessUserReducerType>(defaultState, {
    [ActionType.DELETE_BUSINESS_USER](state: DeleteBusinessUserReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.DELETE_BUSINESS_USER_ERROR](
      state: DeleteBusinessUserReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.DELETE_BUSINESS_USER_SUCCESS](
      state: DeleteBusinessUserReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        deleteBusinessUserResponse: action.payload,
      };
    },

    [ActionType.DELETE_BUSINESS_USER_RESET](
      state: DeleteBusinessUserReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        deleteBusinessUserResponse: undefined,
      };
    },
  });
